"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Upload from foundation/Upload
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Export = createSVGIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M10.91 9.554v1.937a.276.276 0 0 1-.274.276H1.364a.275.275 0 0 1-.273-.276V9.554a.55.55 0 0 0-.546-.553.55.55 0 0 0-.545.553v2.49c0 .457.37.83.82.83h10.36c.452 0 .82-.37.82-.83v-2.49a.55.55 0 0 0-.546-.553.55.55 0 0 0-.545.553M9.648 3.469 6.469.203a.663.663 0 0 0-.958.003L2.35 3.47c-.513.522.257 1.304.77.783l2.144-2.18c.105-.108.19-.07.19.082V8.17c0 .306.242.554.545.554a.55.55 0 0 0 .544-.554V2.154c0-.153.086-.19.191-.083l2.144 2.18c.513.522 1.283-.26.77-.782"
  />,
  "Export",
  {
    viewBox: "0 0 12 13",
    titleAccess: "Export",
    fill: "none",
    className: legacyIconCls(),
  }
);
